import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureCasingProfile } from "../../../hooks/Capture";
import CasingProfiles from "../CasingProfile/CasingProfiles";

interface CasingProfileTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const CasingProfileTab: React.FC<CasingProfileTabProps> = ({ captureId, handleError, canEdit }) => {
  const { casingProfilesData, isPending, createCasingProfile, updateCasingProfile, deleteCasingProfile } = useCaptureCasingProfile(captureId);

  if (isPending && casingProfilesData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CasingProfiles
      casingProfilesData={casingProfilesData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createCasingProfile(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateCasingProfile({ profileId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteCasingProfile(id).catch(handleError);
      }}
    />
  );
};

export default CasingProfileTab;
